import { isAxiosError } from "axios";

import { toastActions } from "src/design-system/Toast/utils";
import { logger } from "src/utils/logger";
import { isPreconditionError } from "src/utils/predicates";

export const toastCaseError = (
  error: unknown,
  title: string,
  preconditionDescription?: string,
): void => {
  logger.error(`${title}:`, error);

  if (isPreconditionError(error)) {
    toastActions.failure({
      title,
      description:
        preconditionDescription ??
        "The resource has been modified elsewhere. Please reload and try again.",
    });
  } else if (isAxiosError(error)) {
    toastActions.failure({
      title,
      description: error.response?.data?.message,
    });
  } else {
    toastActions.failure({
      title,
      description: "An unexpected error occurred. Please try again.",
    });
  }
};
